<template>
    <div class="CoverageFormat">
      <Helmet>
        <title>Internet in Afghanistan - inte-QT</title>
        <meta name="title" content="Internet in Afghanistan - inte-QT" />
        <meta
          name="description"
          content="Afghanistan, with a population of 41.1 million, faces unique challenges in connectivity. inte-QT provides tailored solutions to enable access to essential services."
        />
        <meta
          name="keywords"
          content="internet in Afghanistan, Afghanistan internet providers, Kabul connectivity, mobile networks Afghanistan, broadband Afghanistan"
        />
        <link rel="canonical" href="https://www.inte-qt.com/coverage/afghanistan" />
      </Helmet>

      <img
        src="/images/iI9URSO.jpg"
        alt="Afghanistan Landscape"
        class="banner-img CoverageFormat__saturation"
      />

      <section class="mt-5">
        <nav class="container">
          <ul>
            <li>
              <strong>Population:</strong> 41.1 million (2023 estimate)
            </li>
            <li>
              <strong>Neighboring Countries:</strong>Borders with Pakistan (south & east), Iran (west), 
Turkmenistan, Uzbekistan, and Tajikistan (north), and China (northeast).
            </li>
            <li>
              <strong>Languages Spoken:</strong> Pashto, Dari (Persian),  Other 
languages include Uzbek and Turkmen
            </li>
            <li>
              <strong>Currency:</strong> Afghan Afghani (AFN)
            </li>
            <li>
              <strong>Industries:</strong> Agriculture, Textiles, Mining, Handicrafts, Construction.
            </li>
            <li>
              <strong>Employment Rate:</strong> Predominantly agriculture-based employment, with informal 
sectors playing a large role.
            </li>
            <li>
              <strong>Top 3 Cities:</strong> Kabul, Kandahar, Herat
            </li>
            <li>
              <strong>Tourism:</strong> Limited due to security concerns; pre-2000s saw over 60,000 tourists annually
            </li>
            <li>
              <strong>Weather:</strong> Mostly arid, with cold winters and hot summers
            </li>
            <li>
              <strong>National Sport:</strong>Cricket is the most popular sport, followed by football and 
Buzkashi (traditional horseback game).
            </li>
          </ul>

          <div class="text-center">
            <img
              src="/images/8edGfwB.jpg"
              alt="Afghanistan Flag"
              class="my-5"
              style="width: 150px"
            />
          </div>
        </nav>

        <article>
          <h2>A Brief Overview of Afghanistan</h2>
          <p>
            Afghanistan is a landlocked country located in South Asia and Central Asia. Kabul, the capital, is the center of political and economic activities. Due to its diverse cultural heritage and natural landscapes, Afghanistan has significant potential in tourism, but political instability and security concerns have limited its growth.
          </p>

          <p>
            Afghanistan's internet infrastructure is evolving, with mobile internet being the most common way of accessing the web. However, the lack of direct access to submarine cables and reliance on neighboring countries for connectivity has posed challenges in terms of speed and reliability.
          </p>

          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8391855.841931678!2d60.6652585709846!3d33.93218441864661!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38d16eb08f77f3a9%3A0x9d17dfb42b4b8f4a!2sAfghanistan!5e0!3m2!1sen!2sus!4v1700000000000"
            width="95%"
            height="450"
            style="border: 0"
            allowfullscreen=""
            loading="lazy"
            title="Afghanistan Map"
            class="CoverageFormat__margins"
          ></iframe>

          <h4>Main Airports</h4>
          <ul>
            <li>Hamid Karzai International Airport (Kabul)</li>
            <li>Kandahar International Airport</li>
            <li>Herat International Airport</li>
          </ul>

        </article>
      </section>

      <div class="container">
        <h4>Connectivity Overview</h4>
        <table class="table table-striped table-responsive">
          <thead>
            <tr>
              <th>Type</th>
              <th>Estimated Users</th>
              <th>Penetration</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Broadband Users</td>
              <td>26,570</td>
              <td>&lt;0.1% </td>
            </tr>
            <tr>
              <td>Mobile Cellular Users</td>
              <td>23 million</td>
              <td>~54%</td>
            </tr>
            <tr>
              <td>Landline</td>
              <td>181,963</td>
              <td>&lt;0.5%</td>
            </tr>
            <tr>
              <td>Access to internet</td>
              <td>13.2 million</td>
              <td>30.05%</td>
            </tr>
          </tbody>
        </table>

        <div class="container">
        <h4 class="my-5">Submarine Cables: Afghanistan Internet Backbone</h4>
        <p></p>Afghanistan is a landlocked country and does not have direct access to 
submarine cables. It relies on fiber-optic connections through neighboring 
countries (Iran, Pakistan, and China) for international connectivity.
Fiber optic and satellite connectivity are used to bring internet services into 
the country, which limits internet speed and reliability in certain areas.
        <a
          href="https://www.submarinecablemap.com/country/afghanistan"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/images/fA7SRVj.jpg"
            alt="Submarine Cables Afghanistan"
            width="100%"
          />
        </a>

        <h4>Internet Providers in Afghanistan</h4>
        <p>
          The key internet providers in Afghanistan include: Roshan (one of the largest mobile and internet providers),Etisalat Afghanistan (a significant mobile operator),Afghan Telecom (state-owned, offers fixed-line and broadband), MTN Afghanistan (though it’s in the process of exiting the 
market)
        </p>

        <h5>Our Capabilities</h5>
        <p>Our local partnerships and fiber-backed infrastructure enable us to deliver 
services in Kabul, Herat, and Mazar-i-Sharif, tailored to the needs of 
industries like logistics, humanitarian aid, and government operations</p>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">Capabilities</th>
              <th scope="col"><i class="fas fa-check"></i></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Dedicated Internet Access (DIA)</td>
              <td><i class="fas fa-check"></i></td>
            </tr>
            <tr>
              <td>Business Broadband (BB) </td>
              <td><i class="fas fa-check"></i></td>
            </tr>
            <tr>
              <td>Wireless Connectivity</td>
              <td><i class="fas fa-check"></i></td>
            </tr>
            <tr>
              <td>Service Level Agreements (SLA)</td>
              <td><i class="fas fa-check"></i></td>
            </tr>
            <tr>
              <td>Customer Premises Equipment (CPE) / 
Routers</td>
              <td><i class="fas fa-check"></i></td>
            </tr>
            <tr>
              <td>Global Enterprise Management 
Solutions (GEMS)</td>
              <td><i class="fas fa-check"></i></td>
            </tr>
            <tr>
              <td>Diverse Gateway Solutions</td>
              <td><i class="fas fa-check"></i></td>
            </tr>
            <tr>
              <td>Distributed Denial of Service (DDoS) 
Protection</td>
              <td><i class="fas fa-check"></i></td>
            </tr>
          </tbody>
        </table>

        <p class="CoverageFormat__tag CoverageFormat__margins" align="justify">
          Contact us to receive a <mark>Commercial Offer in 2–4 working days</mark>. With our Global Business Solutions team, we can provide a Commercial Offer in 2–
4 working days, and our Global Operations team can deliver services in Kabul and 
Herat within 3 to 4 weeks, and in other regions such as Mazar-i-Sharif or Kandahar
within 5 to 6 weeks, subject to regional availability and logistical considerations.</p>

        <p class="text-center">
          For more information, please{' '}
          <a href="mailto:sales@inte-QT.com?subject=Mail from Our Site">Email Us</a>.
        </p>

        <h4>* - References</h4>
        <ul>
          <li>
            <a
              href="https://data.worldbank.org/country/afghanistan"
              rel="noopener noreferrer"
              target="_blank"
            >Reference 1</a>
          </li>
          <li>
            <a
              href="https://www.cso.gov.af/"
              rel="noopener noreferrer"
              target="_blank"
            >Reference 2</a>
          </li>
        </ul>
      </div>
      </div>

      <GetInTouch />
    </div>
  </template>

  <script>
    export default {
      name: 'AfghanistanPage',
      meta() {
        return {
          title: 'Internet in Afghanistan - inte-QT',
          meta: [
            { name: 'description', content: 'Afghanistan, with a population of 41.1 million, faces unique challenges in connectivity.' },
            { name: 'keywords', content: 'internet in Afghanistan, Afghanistan internet providers, Kabul connectivity, mobile networks Afghanistan, broadband Afghanistan' },
          ]
        };
      }
    };
  </script>

  <style scoped>
    .CoverageFormat {
      color: black;
    }

    .CoverageFormat__title {
      position: absolute;
      width: 50vw;
      top: 15vh;
      left: 25vw;
      line-height: 1.5;
      font-size: 3rem;
      font-weight: 500; 
      color: #ffffff;  
    }

    @media (max-width: 992px) {
      .CoverageFormat__title {
        font-size: 3rem;
        width: 40vw;
        top: 30vh;
        left: 55vw;
      }
    }

    @media (max-width: 768px) {
      .CoverageFormat__title {
        font-size: 2rem;
        width: 40vw;
        top: 25vh;
        left: 55vw;
      }
    }

    @media (max-width: 576px) {
      .CoverageFormat__title {
        top: 12vh;
        left: 5vw;
        width: 90vw;
        font-size: 1.5rem;
      }
    }

    .CoverageFormat__tag {
      font-size: 1.5rem;
    }

    .CoverageFormat section {
      display: -webkit-flex;
      display: flex;
    }

    .CoverageFormat nav {
      -webkit-flex: 1;
      -ms-flex: 1;
      flex: 1;
    }

    .CoverageFormat nav ul {
      padding: 0;
    }

    .CoverageFormat ul li,
    .CoverageFormat ol li {
      margin: 1rem;
      text-align: left;
    }

    .CoverageFormat article {
      color: black;
      -webkit-flex: 3;
      -ms-flex: 3;
      flex: 3;
      padding: 10px;
    }

    .CoverageFormat__saturation {
      filter: drop-shadow(1px 10px 40px rgb(0, 0, 0)) saturate(110%);
    }

    .CoverageFormat__margins {
      margin: 3rem;
    }

    @media (max-width: 768px) {
      .CoverageFormat__margins {
        margin: 1rem 0 1rem 0;
        text-align: left;
      }
    }

    .CoverageFormat__flag {
      width: 150px;
      border: 1px solid black;
    }

    @media (max-width: 768px) {
      .CoverageFormat section {
        -webkit-flex-direction: column;
        flex-direction: column;
      }
    }
  </style>
